import { isNumber } from 'lodash-es'
import {
  type AvailableUnlockData,
  type StatisticStatusValue,
} from '@/types/schema/kol/unlock'

export const isAllPlatformStatisticStatusValue = (
  status: AvailableUnlockData['status'],
): status is StatisticStatusValue => isNumber(status)
